import React, { Component } from "react";
import Form from "react-jsonschema-form-bs4";
import Geyser from "../Geyser/Geyser";
import PropertyLoss from "../PropertyLoss/PropertyLoss";
import Windscreen from "../Windscreen/Windscreen";
import PublicLiability from "../PublicLiability/PublicLiability";
import VehicleLoss from "../VehicleLoss/VehicleLoss";
import VehicleCollision from "../VehicleCollision/VehicleCollision";
import schema from "wn-claims-shared/dist/schema/form-selection-schema";
import uiSchema from "./uiSchema";
import $ from "jquery";

const uuidv4 = require("uuid/v4");
const log = type => console.log.bind(console, type);

export class FormSelection extends Component {
  constructor() {
    super();

    this.state = {
      selectedForm: {}
    };
    this.selectedForm = {};
  }
  // TODO: move to utils
  validateTelNumbers = (formData, errors) => {
    const phoneno = /^\d{10}$/;
    // FIXME: is it possible to use a universal telephone type to flag telephone number validations instead of hardcoding? if not move to a config file
    const telephoneKeys = [
      "brokertel",
      "insuredtel"
    ];

    telephoneKeys.forEach(element => {
      //console.log(element);
      if (formData.hasOwnProperty(element) && formData[element]) {
        if (!formData[element].match(phoneno)) {
          errors[element].addError("Not a valid contact number.");
        }
      }

    });
    return errors;
  };

  handleFormSelection = ({ formData }, e) => {
    // TODO: move formselection logic out of AppRouter
    const fD = { ...formData }; // Create a deep copy of formdata
    fD.formguid = uuidv4(); // Generate new guid (uuid/v4)
    this.setState({ selectedForm: fD }); // Save formdata to state
    this.selectedForm = fD;
    console.log(fD);
    console.log("form selected:", this.state.selectedForm);
  };

  handleFieldChange = (event, formData) => {
    log("changes");
    
    var str = "";

    // Check claim type category = Motor
    if (event.formData.claimtypeCat == "Motor") {
      event.uiSchema.claimMotor.classNames = "";
      $("#root_claimMotor").parent().removeClass("hidden");
      //Show third party section if Accident Collision selected
      var selected = $("#root_claimMotor :selected").text();
      if (selected == "Accident Collision"){
        $("#root_thirdparty").parent().removeClass("hidden");      
      }

      str = event.formData.claimMotor;
    } else {
      event.uiSchema.claimMotor.classNames = "hidden";
      $("#root_claimMotor").parent().addClass("hidden");
      $("#root_thirdparty").parent().addClass("hidden");
      $("#root_claimMotor").prop("selectedIndex", 0);
    }

    // Check claim type category = Non-Motor
    if (event.formData.claimtypeCat == "Non-motor") {
      event.uiSchema.claimNonMotor.classNames = "";
      $("#root_claimNonMotor").parent().removeClass("hidden");
      str = event.formData.claimNonMotor;  
    } else {
      event.uiSchema.claimNonMotor.classNames = "hidden";
      $("#root_claimNonMotor").parent().addClass("hidden");
      $("#root_claimNonMotor").prop("selectedIndex", 0);
    }

    // Update the claimtype
    event.formData.claimtype = str;
    $("#root_claimtype").val(str);

  };

  render() {
    const { selectedForm } = this.state;

    // TODO: move formselection logic out of AppRouter
    /* TODO: move component definitions inside below switch statement, 
        no need to have a seperate component for each form, 
        just need to pass the form's schema, 
        uiSchemas and formdata here instead of the component, 
        use a standard wizard wrapper component to contain Wizard components */
    let selectedFormComponent;
    switch (selectedForm.claimtype) {
      case "Geyser":
        selectedFormComponent = <Geyser selectFormData={this.selectedForm} />;
        break;
      case "Vehicle Stolen or Hijacked":
        selectedFormComponent = <VehicleLoss selectFormData={this.selectedForm} />;
        break;
      case "Accident Collision":
          selectedFormComponent = <VehicleCollision selectFormData={this.selectedForm} />;
          break;
      case "Motor Vehicle Windscreen":
        selectedFormComponent = <Windscreen selectFormData={this.selectedForm} />;
        break;
      case "Property Loss or Damage":
        selectedFormComponent = <PropertyLoss selectFormData={this.selectedForm} />;
        break;
      case "Public Liability":
        selectedFormComponent = <PublicLiability selectFormData={this.selectedForm} />;
        break;
      default:
        selectedFormComponent = <div>no form selected</div>;
        break;
    }
    const formSelect = (
      <div>
        <Form
          schema={schema}
          uiSchema={uiSchema}
          formData={this.selectedForm}
          onChange={this.handleFieldChange}
          onSubmit={this.handleFormSelection.bind(this)}
          onError={log("errors")}
          validate={this.validateTelNumbers}
        >
          <div>
            <button className="btn btn-primary" type="submit">
              Next
            </button>
          </div>
        </Form>
      </div>
    );
    return <div>{this.state.selectedForm.formguid ? selectedFormComponent : formSelect}</div>;
  }
}

export default FormSelection;
